export default "/images/sidebar-3.jpg?547b2a0050ac5a652cd7c9d12444e952";